"use strict";

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.object.define-property");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var r = e(require("@babel/runtime/helpers/slicedToArray")),
    n = require("react"),
    t = e(require("@babel/runtime/helpers/objectSpread2")),
    a = n.createContext(null);

function u() {
  var e = n.useContext(a);
  return e;
}

var l = /<(\d+)>(.*)<\/\1>|<(\d+)\/>/,
    i = /(?:\r\n|\r|\n)/g;

function o(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      a = e.replace(i, "").split(l);
  if (1 === a.length) return e;
  var u = [],
      c = a.shift();
  c && u.push(c);
  var s = !0,
      f = !1,
      d = void 0;

  try {
    for (var v, p = function e(n) {
      if (!n.length) return [];
      var t = n.slice(0, 4),
          a = r(t, 4),
          u = a[0],
          l = a[1],
          i = a[2],
          o = a[3];
      return [[parseInt(u || i), l || "", o]].concat(e(n.slice(4, n.length)));
    }(a)[Symbol.iterator](); !(s = (v = p.next()).done); s = !0) {
      var h = r(v.value, 3),
          m = h[0],
          y = h[1],
          g = h[2],
          b = t[m];
      u.push(n.cloneElement(b, {
        key: m
      }, y ? o(y, t) : b.props.children)), g && u.push(g);
    }
  } catch (e) {
    f = !0, d = e;
  } finally {
    try {
      s || null == p["return"] || p["return"]();
    } finally {
      if (f) throw d;
    }
  }

  return u;
}

function c(e) {
  var r = u(),
      a = r.i18n,
      l = r.defaultRender,
      i = e.render,
      c = void 0 === i ? l : i,
      s = e.id,
      f = e.message,
      d = e.formats,
      v = t({}, e.values),
      p = t({}, e.components);
  v && Object.keys(v).forEach(function (e) {
    var r = v[e];

    if (n.isValidElement(r)) {
      var t = Object.keys(p).length;
      p[t] = r, v[e] = "<".concat(t, "/>");
    }
  });
  var h = a && "function" == typeof a._ ? a._(s, v, {
    message: f,
    formats: d
  }) : s,
      m = h ? o(h, p) : null;
  return null == c ? m : "string" == typeof c ? n.createElement(c, {}, m) : n.isValidElement(c) ? n.cloneElement(c, {}, m) : n.createElement(c, {
    id: s,
    translation: m,
    message: f
  });
}

c.defaultProps = {
  values: {},
  components: {}
}, exports.I18nProvider = function (e) {
  var t = n.useState(o()),
      u = r(t, 2),
      l = u[0],
      i = u[1];

  function o() {
    return {
      i18n: e.i18n,
      defaultRender: e.defaultRender
    };
  }

  return n.useEffect(function () {
    var r = e.i18n.on("change", function () {
      return i(o());
    });
    return function () {
      return r();
    };
  }, []), n.createElement(a.Provider, {
    value: l
  }, l.i18n.locale && e.children);
}, exports.Trans = c, exports.useLingui = u;